import { render, staticRenderFns } from "./ChatBody.vue?vue&type=template&id=4b30c4f1&scoped=true&"
import script from "./ChatBody.vue?vue&type=script&lang=js&"
export * from "./ChatBody.vue?vue&type=script&lang=js&"
import style0 from "./ChatBody.vue?vue&type=style&index=0&id=4b30c4f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b30c4f1",
  null
  
)

export default component.exports